// Copyright (c) StrangeBee 2023

// insert element in array at specific index or at the end if index doesn't exists
// eslint-disable-next-line
export const addElementOnArray = (list: Array<any>, element: any, index?: number): any[] => {
    if (index || index === 0) {
        return [...list.slice(0, index), element, ...list.slice(index)];
    }
    return [...list, element];
};

// remove element in array at specific index
export const deleteElementOnArray = (list: Array<any>, index: number): any[] =>
    list.filter((_, curIndex) => curIndex !== index);

const fixIndex = (originIndex: number, destinationIndex: number): number => {
    return originIndex > destinationIndex ? destinationIndex : destinationIndex - 1;
};

export const moveElementOnArray = (list: Array<any>, originIndex: number, destinationIndex?: number): any[] => {
    const filteredArray = deleteElementOnArray(list, originIndex);
    return addElementOnArray(
        filteredArray,
        list[originIndex],
        destinationIndex || destinationIndex === 0 ? fixIndex(originIndex, destinationIndex) : undefined,
    );
};

export const mergeTag = (tagsOrigin: string[], tagsExtern: string[], tagsUpdated: string[]): string[] => {
    const removedTagByUser = tagsOrigin.filter((tag) => !tagsUpdated.includes(tag));
    const removedTagByExternal = tagsOrigin.filter((tag) => !tagsExtern.includes(tag));

    const tagsMerged = Array.from(new Set([...tagsExtern, ...tagsUpdated]));

    return tagsMerged.filter((tag) => !removedTagByUser.includes(tag) && !removedTagByExternal.includes(tag));
};

export const sortStrings = (stringA: string, stringB: string): number => stringA.localeCompare(stringB);

export const sortNumbers = (numA: number, numB: number): number => numA - numB;
